import {HOST_API} from "@/config-global";

import {RecipeCreateInput, RecipeUpdateInput, RecipeCreateUpdateOutput} from "@/types";

const RECIPE_SAVE_URI = "/api/recipe/save";


export async function sendRecipe(recipeRequestDto: RecipeCreateInput|RecipeUpdateInput): Promise<RecipeCreateUpdateOutput> {
  const response = await fetch(`${HOST_API}${RECIPE_SAVE_URI}`, {
    method: recipeRequestDto.id ? "PUT" : "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
    },
    body: JSON.stringify(recipeRequestDto)
  });

  if (!response.ok) {
    throw new Error("Failed to send recipe");
  }

  return (await response.json()) as RecipeCreateUpdateOutput;
}

